import '@cloudscape-design/global-styles/index.css';
import { Amplify } from 'aws-amplify';
import { Settings } from 'luxon';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import ProtectedRoute from './lib/ProtectedRoute';
import PublicRoute from './lib/PublicRoute';
import Login from './pages/Login';
import Logout from './pages/Logout';
import RouteNotFound from './pages/RouteNotFound';
import UserInformations from './pages/userinformations/Userinformations';
import About from './pages/website/about/About';
import EventEntries from './pages/website/events/evententries/EventEntries';
import Events from './pages/website/events/Events';
import Additives from './pages/website/food/additives/Additivies';
import Allergens from './pages/website/food/allergens/Allergens';
import Food from './pages/website/food/Food';
import FoodCategories from './pages/website/food/foodcategories/FoodCategories';
import FoodMenues from './pages/website/food/foodmenues/FoodMenues';
import Gallery from './pages/website/gallery/Gallery';
import Legal from './pages/website/legal/Legal';
import Articles from './pages/website/news/articles/Articles';
import News from './pages/website/news/News';
import Partners from './pages/website/partners/Partners';
import Website from './pages/website/Website';
import WeeklyFoodMenues from './pages/website/weeklymenue/foodmenues/FoodMenues';
import WeeklyMenue from './pages/website/weeklymenue/WeeklyMenue';

Settings.defaultLocale = 'de-DE';

Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_USER_POOL_ID!,
        userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!,
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID!,
      },
    },
    Storage: {
      S3: {
        bucket: process.env.REACT_APP_UPLOAD_BUCKET,
        region: 'eu-central-1',
      },
    },
  },
  { ssr: true },
);

export type ComponentMappingConfig = {
  component: React.JSX.Element;
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route index path="/" element={<PublicRoute element={Login} />} />
          <Route path="/login" element={<PublicRoute element={Login} />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/userinformations"
            element={<ProtectedRoute element={UserInformations} />}
          />
          <Route
            path="/website"
            element={<ProtectedRoute element={Website} />}
          />
          <Route
            path="/website/weeklymenue"
            element={<ProtectedRoute element={WeeklyMenue} />}
          />
          <Route
            path="/website/weeklymenue/menues/:week"
            element={<ProtectedRoute element={WeeklyFoodMenues} />}
          />
          <Route
            path="/website/food"
            element={<ProtectedRoute element={Food} />}
          />
          <Route
            path="/website/food/foodcategories"
            element={<ProtectedRoute element={FoodCategories} />}
          />
          <Route
            path="/website/food/menues"
            element={<ProtectedRoute element={FoodMenues} />}
          />
          <Route
            path="/website/food/allergens"
            element={<ProtectedRoute element={Allergens} />}
          />
          <Route
            path="/website/food/additives"
            element={<ProtectedRoute element={Additives} />}
          />
          <Route
            path="/website/gallery"
            element={<ProtectedRoute element={Gallery} />}
          />
          <Route
            path="/website/news"
            element={<ProtectedRoute element={News} />}
          />
          <Route
            path="/website/news/articles"
            element={<ProtectedRoute element={Articles} />}
          />
          <Route
            path="/website/events"
            element={<ProtectedRoute element={Events} />}
          />
          <Route
            path="/website/events/evententries"
            element={<ProtectedRoute element={EventEntries} />}
          />
          <Route
            path="/website/about"
            element={<ProtectedRoute element={About} />}
          />
          <Route
            path="/website/partners"
            element={<ProtectedRoute element={Partners} />}
          />
          <Route
            path="/website/legal"
            element={<ProtectedRoute element={Legal} />}
          />
          <Route path="*" element={<RouteNotFound />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
